import { twMerge } from 'tailwind-merge';
import { isBlank } from '@witmetrics/utils/strings';
import { useString } from '@/hooks/useString';
import Button from '@/components/Button';
import TextField from '@/components/inputs/TextField';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import type { NewLeadData } from '../types';
import { classes } from './utils';

export type NewLeadFormProps = {
  disabled?: boolean;
  isSaving?: boolean;
  onSave: (data: NewLeadData) => void;
};

export default function NewLeadForm({
  disabled,
  isSaving,
  onSave,
}: NewLeadFormProps) {
  const [firstname, setFirstname] = useString();
  const [lastname, setLastname] = useString();
  const [email, setEmail] = useString();
  const [externalRef, setExternalRef] = useString();

  const handleSave = async () => {
    if (isBlank(firstname)) return null; // Just in case button wasn't disabled for some reason
    onSave({ firstname, lastname, email, externalRef });
  };

  const sharedProps = {
    disabled: disabled || isSaving,
    autoComplete: 'new-password',
  };
  const isFormBlank = isBlank(`${firstname}${lastname}${email}${externalRef}`);
  return (
    <div className={classes.form}>
      <TextField
        {...sharedProps}
        label="First name*"
        value={firstname}
        onChange={setFirstname}
      />
      <TextField
        {...sharedProps}
        label="Last name"
        value={lastname}
        onChange={setLastname}
      />
      <TextField
        {...sharedProps}
        label="Email"
        value={email}
        onChange={setEmail}
      />
      <TextField
        {...sharedProps}
        label="External Ref."
        value={externalRef}
        onChange={setExternalRef}
      />
      <Button
        disabled={isBlank(firstname) || disabled || isSaving}
        className={twMerge(classes.button, isFormBlank && classes.hidden)}
        onClick={handleSave}>
        {isSaving ? (
          <>
            Saving
            <LoopingEllipsis />
          </>
        ) : (
          'Save & continue'
        )}
      </Button>
    </div>
  );
}
